import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "../link";
import { ITeam } from "../../types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(2, 2)
    }
  })
);

const Breadcrumb = ({ team }: { team: ITeam }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" to="/">
            Teams
          </Link>
          <Typography color="textPrimary">{team.name}</Typography>
        </Breadcrumbs>
      </Paper>
      <br />
    </div>
  );
};

export default Breadcrumb;
